import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Box, makeStyles } from '@popmenu/common-ui';
import { CheckEmailPage } from '../CheckEmailPage';
import { DishCategoryPage } from '../DishCategoryPage';
import { DishFeedPage } from '../DishFeedPage';
import { DishListIndexPage } from '../DishListIndexPage';
import { DishListPage } from '../DishListPage';
import { ForYouPage } from '../ForYouPage';
import { ProfilePage } from '../ProfilePage';
import { RefinePage } from '../RefinePage';
import { SignInPage } from '../SignInPage';
import { WelcomePage } from '../WelcomePage';

const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 auto',
    maxWidth: `calc(1200px + ${theme.spacing(8)}px)`,
    minWidth: `calc(256px + ${theme.spacing(8)}px)`,
    padding: theme.spacing(4),
  },
}));

export const PageContent = () => {
  const classes = useStyles();

  return (
    <Box component="section">
      <Box className={classes.container}>
        <Switch>
          <Route exact path="/sign-in">
            <SignInPage />
          </Route>
          <Route exact path="/sign-in/check-email">
            <CheckEmailPage />
          </Route>
          <Route exact path="/welcome">
            <WelcomePage />
          </Route>
          <Route exact path="/refine">
            <RefinePage />
          </Route>
          <Route exact path="/profile">
            <ProfilePage />
          </Route>
          <Route path="/lists/:dishListSlug">
            <DishListPage />
          </Route>
          <Route path="/lists">
            <DishListIndexPage />
          </Route>
          <Route path="/places/:placeSlug/for-you">
            <ForYouPage />
          </Route>
          <Route path="/places/:placeSlug/categories/:categorySlug">
            <DishCategoryPage />
          </Route>
          <Route path="/places/:placeSlug">
            <DishFeedPage />
          </Route>
          <Route path="/">
            <DishFeedPage />
          </Route>
        </Switch>
      </Box>
    </Box>
  );
};
